import React, { useRef, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useTabContext } from '../../contexts/TabContext';
import styles from './Header.module.css';
import tabStyles from './TabBar.module.css';

function TabsRow() {
  const { tabs, activeId, activateTab, closeTab } = useTabContext();
  const navigate = useNavigate();
  const barRef   = useRef(null);
  const activeRef = useRef(null);

  useEffect(() => {
    if (activeRef.current) {
      activeRef.current.scrollIntoView({ block: 'nearest', inline: 'nearest', behavior: 'smooth' });
    }
  }, [activeId]);

  if (tabs.length === 0) return null;

  const handleClick = (tab) => {
    activateTab(tab.path);
    navigate(tab.path);
  };

  const handleClose = (e, tab) => {
    e.stopPropagation();
    closeTab(tab.path, navigate);
  };

  const handleWheel = (e) => {
    if (barRef.current) {
      e.preventDefault();
      barRef.current.scrollLeft += e.deltaY;
    }
  };

  return (
    <div ref={barRef} className={tabStyles.bar} onWheel={handleWheel}>
      {tabs.map(tab => {
        const ativo = tab.path === activeId;
        return (
          <div
            key={tab.path}
            ref={ativo ? activeRef : null}
            className={`${tabStyles.tab} ${ativo ? tabStyles.tabAtivo : ''}`}
            onClick={() => handleClick(tab)}
            title={tab.label}
          >
            <span className={tabStyles.icon}>{tab.icon}</span>
            <span className={tabStyles.label}>{tab.label}</span>
            <button
              className={tabStyles.close}
              onClick={e => handleClose(e, tab)}
              title="Fechar aba"
            >×</button>
          </div>
        );
      })}
    </div>
  );
}

// Notificações e liberações de senha moraram aqui antes — agora ficam na
// Sidebar (embaixo da logo), pra essa barra só existir quando tem aba
// aberta (sem abas = zero altura, mais espaço vertical pra tela atual).
export default function Header() {
  const { tabs } = useTabContext();
  if (tabs.length === 0) return null;

  return (
    <header className={styles.header}>
      <TabsRow />
    </header>
  );
}
